import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

import './styles.css'
import reportWebVitals from './reportWebVitals.ts'
import { AuthProvider } from './auth/AuthContext.tsx'
import userManager from './auth/authService.ts'
import type { RouterContext } from './router-context.ts'
import 'nprogress/nprogress.css';
import * as Sentry from "@sentry/react";


Sentry.init({
  dsn: "https://f8599ee97292344b4e0d5a86784a16ea@sentry.brainfarm.dev/3",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    userManager,
    user: null, // Initially set to null, will be updated in AuthProvider
  } as RouterContext,
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  basepath: import.meta.env.MODE === "quality" ? "test.closing-dashboard-gbs" : "closing-dashboard-gbs"
});

const queryClient = new QueryClient()

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
//   declare module '@tanstack/react-router' {
//   interface Register {
//     router: typeof router
//   }
// }
// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

